<p-card *ngIf="!isSpecialMemberOfferFormUrl">
    <ng-container *ngTemplateOutlet="specialOfferContent"></ng-container>
</p-card>
<ng-container *ngIf="isSpecialMemberOfferFormUrl">
    <ng-container *ngTemplateOutlet="specialOfferContent"></ng-container>
</ng-container>

<ng-template #specialOfferContent>
    <!-- Display member name and address -->
    <div *ngIf="!formSubmitted">
        <div class="mt-4 text-left custom-bold line-height-3">
            <div class="text-slate-950 font-medium text-sm md:text-base lg:text-base">{{ firstName }} {{ lastName }}
            </div>
            <div class="font-medium m-0 text-slate-950 text-sm md:text-base lg:text-base"><span
                    class="first-letter-capital">{{
                    address }}</span>, <span class="first-letter-capital">{{ city }}</span>,
                <span class="first-letter-capital">{{ state }}</span>,{{ zip }}
            </div>
        </div>
        <p-divider class="bg-slate-200" />
        <form [formGroup]="specialOfferForm" (ngSubmit)="onSubmit(specialOfferForm)" class="pt-3">
            <div class="flex flex-column w-full" [ngClass]="{'md:flex-row md:gap-3': isSpecialMemberOfferFormUrl}">
                <div class="p-fieldset field" [ngClass]="{'md:w-6': isSpecialMemberOfferFormUrl}">
                    <label for="special-offer-phone" class="custom-bold text-slate-950">Phone number</label>
                    <div *ngIf="specialOfferForm.controls['phone'].touched && specialOfferForm.controls['phone'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <input id="special-offer-phone" type="text" pInputText class="w-full" formControlName="phone"
                        data-auto-id="special-offer-phone" aria-describedby="phone-help">
                    <small id="phone-help"
                        *ngIf="specialOfferForm.controls['phone'].invalid && specialOfferForm.controls['phone'].touched && !specialOfferForm.controls['phone'].errors?.['required']"
                        class="mt-1 text-rose-600" data-auto-id="special-offer-phone-validation-error">
                        Please enter a valid phone number
                    </small>
                </div>
                <div class="p-fieldset field" [ngClass]="{'md:w-6': isSpecialMemberOfferFormUrl}">
                    <label for="special-offer-email" class="custom-bold text-slate-950">Email</label>
                    <div *ngIf="specialOfferForm.controls['email'].touched && specialOfferForm.controls['email'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <input id="special-offer-email" type="text" pInputText class="w-full" formControlName="email"
                        data-auto-id="special-offer-email" aria-describedby="email-help">
                    <small id="email-help"
                        *ngIf="specialOfferForm.controls['email'].invalid && specialOfferForm.controls['email'].touched && !specialOfferForm.controls['email'].errors?.['required']"
                        class="mt-1 text-rose-600" data-auto-id="special-offer-email-validation-error">
                        The email you entered is invalid
                    </small>
                </div>
            </div>
            <div class="flex flex-column md:flex-row w-full py-4">
                <p-button type="submit" [rounded]="true" severity="primary" data-auto-id="special-offer-submit"
                    [disabled]="!specialOfferForm.valid || isSubmitForm"
                    class="flex align-items-center justify-content-center w-full flex-order-0 md:flex-order-1"
                    styleClass="w-full">
                    <ng-container *ngIf="isSubmitForm">
                        <i class="pi pi-spin pi-spinner"></i>&nbsp;Submitting
                    </ng-container>
                    <ng-container *ngIf="!isSubmitForm">{{ isSpecialMemberOfferFormUrl? 'Call me' : 'Contact Me' }}
                    </ng-container>
                </p-button>
            </div>
        </form>
        <div class="mt-3 line-height-3" [ngClass]="{'text-slate-500': isSpecialMemberOfferFormUrl}">After you submit this form, a Cinch Home Services representative will contact
            you to review plan options, explain
            coverage details, and complete enrollment if you choose to proceed.</div>
    </div>
    <div *ngIf="formSubmitted" class="text-left p-3">
        <cinch-icon [icon]="'thumbsup'" class="card-icon"></cinch-icon>
        <h2 class="text-slate-950">Request Received!</h2>
        <p class="line-height-3 text-slate-950 text-sm">We'll reach out to {{firstName || 'you'}} shortly to review your
            coverage options
            and get you enrolled.</p>
    </div>
</ng-template>